module.exports = __webpack_public_path__ + "static/media/toilo.120045f7.jpg";